import { Media } from '@pixacare/domain';
import { isOptimisticMedia } from '@shared/store/sequences/is-optimistic-media';
import { mediaContentKey } from '@shared/store/sequences/media-content-key';

// Keeps the freshly attached server medias and preserves any optimistic placeholder the response
// does not yet cover (a sibling still uploading), so a partial success never wipes an in-flight
// media. A placeholder is considered fulfilled — and dropped — once a real media with the same
// content key arrives.
export const mergeWithOptimisticPlaceholders = (attachedMedias: Media[], existingMedias: Media[]): Media[] => {
  const attachedKeys = new Set(attachedMedias.map(mediaContentKey));
  const unfulfilledPlaceholders = existingMedias.filter(
    (media) => isOptimisticMedia(media) && !attachedKeys.has(mediaContentKey(media)),
  );
  return [...attachedMedias, ...unfulfilledPlaceholders];
};
